import { NgModule } from '@angular/core';
import { TableComponent } from './table.component';
import { TableNoDataDirective } from './table.no-data.directive';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ApplyFunctionPipe } from '../shared/apply-function.pipe';

const components = [
    TableComponent,
    TableNoDataDirective,
];
@NgModule({
    declarations: components,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        TranslateModule,

        ApplyFunctionPipe,
    ],
    exports: components,
})
export class TableModule {};
